/**
 * Converts a date object to a formatted date string (i.e. "09/11/24")
 * @param date
 */
export const dateObjectToString = (date: Date): string => {
    const month = ('0' + (date.getMonth() + 1).toString()).slice(-2);
    const day = ('0' + date.getDate().toString()).slice(-2);
    return `${month}/${day}/${date.getFullYear().toString().slice(-2)}`;
};
